module.exports = __webpack_public_path__ + "img/ver1.9958e80c.jpg";